import React from "react";
import { IUIPropertyDefinition } from "../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertySubTitle, PropertyTitle } from "./common";
import { IQueryConditionGroup, QueryBuilderModal, evaluateConditions } from "../query-builder/QueryBuilder";

type IVisibilityPropertyProps = IQueryConditionGroup

export function VisibilityProperty(defaultProps: IVisibilityPropertyProps, title?: string): IUIPropertyDefinition<IVisibilityPropertyProps> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, contextData, containerId) => {

            return <PropertyContainer>
                <PropertyContainerTitle> {title || 'Visibility'}</PropertyContainerTitle>

                <PropertyGroup>
                    <Property>
                        <PropertyTitle>Field Visibility</PropertyTitle>
                        <PropertySubTitle> Field will only be visible if the conditions are true </PropertySubTitle>
                        <QueryBuilderModal
                            uxpContext={uxpContext}
                            uiProps={props.parentUIProps}
                            designer={props.designer}
                            contextData={contextData}
                            conditions={props.uiProps}
                            onChangeConditions={(c) => {
                                props.onChange(c)
                            }}
                        />
                    </Property>
                </PropertyGroup>
            </PropertyContainer>
        }
    }
}